<div class="container-fluid">
  <mat-divider class="mb-4"></mat-divider>
  <div class="row">
    <h3>Participación Sociedades</h3>
  </div>
  <div *ngFor="let activoForm of formArray.controls; let i = index">
    <form [formGroup]="formArray.controls[i]" class="row" class="row" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="col-2">
        <mat-label>Razón Social</mat-label>
        <input matInput formControlName="razonSocial" placeholder="Razon Social">
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="col-2">
        <mat-label>RUT</mat-label>
        <input matInput formControlName="rut" placeholder="XXXXXXXX-X">
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="col-2">
        <mat-label>Patrimonio</mat-label>
        <input matInput currencyMask type="text" formControlName="patrimonio" placeholder="$">
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="col-3">
        <mat-label>Porcentaje de Participación</mat-label>
        <input matInput type="text" formControlName="porcentajeParticipacion" placeholder="%" step="1">
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="col-3">
        <mat-label>Monto de Participación</mat-label>
        <input matInput currencyMask type="text" formControlName="montoParticipacion" placeholder="$">
      </mat-form-field>
  
      <button type="button" mat-icon-button color="warn" (click)="eliminarParticipacion(i)" [disabled]="formFirmado" style="margin: auto;">
        <mat-icon>delete</mat-icon>
      </button>
      <mat-divider class="mb-4"></mat-divider>
    </form>
  </div>
  <div class="row">
    <div class="mt-4">
      <button mat-raised-button color="accent" type="button" class="ml1 mr1 fl" (click)="agregarParticipacion(null)"><mat-icon >add_circle</mat-icon> Agregar participación</button>
      <button id="participacionSiguienteBtn" class="ml1 mr1 fr" mat-raised-button color="primary" (click)="onSubmit()">Siguiente</button>
      <button id="participacionVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
    </div>
  </div>
</div>
